const state = {
  pluginswitch: false,
  baiduadswitch: false,
  baiduseodataswitch: false,
  baiduicpdataswitch: false,
  baidurankswitch: false,
  pagecopyswitch: false,
  poriginalswitch: false,
  rightlistswitch: false,
  version: "",
  logged: false,
  cmseditswitch: false,
  allpmswitch: false
};

export default {
  namespaced: true,
  state
};



// WEBPACK FOOTER //
// ./src/store/popup.js